module.exports = __webpack_public_path__ + "fonts/CircularStd-BoldItalic.8bbbf07a.otf";